import axios from "axios";

const instance = axios.create({
    baseURL:"http://localhost:5001/wuzi-app/us-central1/api"// the api will go here firebase cloud platform
})

//https://us-central1-wuzi-app.cloudfunctions.net/api


export default instance;